// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__FpGId","dragIcon":"Choice_dragIcon__QPG67","left":"Choice_left__3oCbY","input":"Choice_input__1WWTJ"};